// extracted by css-extract-rspack-plugin
export default {"content":"FooterCellContent_content__vlkYJ","center":"FooterCellContent_center__g3axx","left":"FooterCellContent_left__PibPn","right":"FooterCellContent_right__ssqZ9"};